import type {
  APIRequestBody,
  APIRequestPathParams,
  APIResponse,
} from './base-fetch';
import { get, post, remove } from './base-fetch';

export enum TemplateFileType {
  nda = 'nda',
  useCaseDefinition = 'useCaseDefinition',
  pilotPlan = 'pilotPlan',
}

export type Template = APIResponse<'/api/v4/accounts-templates'>[number];
export const fetchTemplates = () => get<Template[]>(`/v4/accounts-templates`);

export type UploadTemplatePayload =
  APIRequestBody<'/api/v4/accounts-templates/upload'> & { file: File };

export const uploadTemplate = (payload: UploadTemplatePayload) => {
  const formData = new FormData();
  formData.append('file', payload.file);
  formData.append('fileType', payload.fileType);

  return post(`/v4/accounts-templates/upload`, formData);
};

type TeamFileScanningStatusParams =
  APIRequestPathParams<'/api/v4/accounts-templates/{fileId}/scanning-status'>;

export type TemplateScanningStatus =
  APIResponse<'/api/v4/accounts-templates/{fileId}/scanning-status'>;

export const fetchTemplateScanningStatus = async ({
  fileId,
}: TeamFileScanningStatusParams) =>
  get<TemplateScanningStatus>(
    `/v4/accounts-templates/${fileId}/scanning-status`,
  );

export type DeleteTemplateParam =
  APIRequestPathParams<'/api/v4/accounts-templates/{fileId}/delete'>;

export const deleteTemplate = (params: DeleteTemplateParam) =>
  remove(`/v4/accounts-templates/${params.fileId}/delete`);
